export const moduloProjeto = 'PROJETOS';
export const moduloCadastroBasico = 'CADASTROS BÁSICOS';
export const moduloContratado = 'MÓDULO CONTRATADO';
export const moduloRelatorioProjeto = 'RELATÓRIO DOS PROJETOS';
export const moduloOrcado = 'MÓDULO ORÇADO';
export const moduloFechamento = 'FECHAMENTO';
export const moduloDashboard = 'DASHBOARD';
export const moduloRequisitado = 'MÓDULO REQUISITADO';
export const moduloExecutado = 'MÓDULO EXECUTADO';
export const moduloRelatirios = 'RELATÓRIOS';
export const moduloConfiguracao = 'CONFIGURAÇÕES';

export const moduloContaResultado = 'CONTA RESULTADO'
export const moduloFechamentoMina = 'FECHAMENTO DE MINA'
